// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3zF6t","search":"Settings_search__3vjVG","filter":"Settings_filter__1t_Oa"};